export default __webpack_public_path__ + "static/media/bl16.d0d756eb.png";